import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { Wrapper, Title, QuizsWrapper, QuizCategory } from './elements';
import { useText } from 'common/hooks';

type Props = {
  readonly className?: string;
  readonly text: string;
  readonly onTagClick: (string) => void;
  readonly isMobile?: boolean;
};

const deps = {
  currentTag: state.challenge.tagModal.key,
  computedTags: state.challenge.log.computedTags,
  userQuizScoreAll: state.challenge.tagModal.computedUserQuizScoreAll,
};

function NewQuiz({
  className,
  currentTag,
  computedTags,
  userQuizScoreAll,
  text,
  onTagClick,
  isMobile,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Wrapper className={className} noBorder={isMobile}>
      <Title>{text}</Title>
      <QuizsWrapper>
        {Object.entries(userQuizScoreAll)
          .filter(([tag]) => computedTags.includes(tag) && tag !== currentTag)
          .map(([tag, userQuizScore]) => (
            <QuizCategory
              isCompleted={userQuizScore.isCompleted}
              key={tag}
              tag={tag}
              text={t(`challenge.tags.${tag}.name`)}
              onClick={() => onTagClick(tag)}
            />
          ))}
      </QuizsWrapper>
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, NewQuiz);
